import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const REQUESTED_MQL_PLUS_COPY = 'REQUESTED_MQL_PLUS_COPY';
export const RECEIVED_MQL_PLUS_COPY = 'RECEIVED_MQL_PLUS_COPY';
export const REQUEST_MQL_PLUS_COPY_FAILED = 'REQUEST_MQL_PLUS_COPY_FAILED';

const getMqlPlusCopy = () => (
  (dispatch) => {
    dispatch({
      type: REQUESTED_MQL_PLUS_COPY,
    });

    const requests = [
      axios.get('/api/features/mql-plus-leads/copy/example-lead'),
      axios.get('/api/features/mql-plus-leads/copy/small-example-leads'),
      axios.get('/api/custom-copy?page=mql-plus-leads'),
    ];

    return Promise
      .all(requests)
      .then((response) => {
        dispatch({
          type: RECEIVED_MQL_PLUS_COPY,
          data:
            {
              example_lead: response[0].data,
              small_example_leads: response[1].data,
              custom_copy: response[2].data,
            },
        });
      }).catch((error) => {
        dispatch({
          type: REQUEST_MQL_PLUS_COPY_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to fetch Mql Plus lead page',
          originalError: error,
        }));
      });
  }
);

export default getMqlPlusCopy;
